import { storageProvider } from '@ocean/configs'
import { LoggerUtils } from '@ocean/utils'

const SSO_MARKER = 'olpsso'
const SSO_INVALID_SESSION = 'sso_is'
const SSO_ERROR_MESSAGE = 'sso_err'

class SsoUtils {
  SSO_INITIALIZATION_ERROR_ID = 'SsoInitError'

  markSso(ecn: string) {
    this.logSso(`Marking client SSO session for encoded customer ${ecn}`)
    localStorage.setItem(SSO_MARKER, ecn)
  }

  getSsoMarker() {
    const value = localStorage.getItem(SSO_MARKER)
    this.logSso(`Checking client SSO session marker - value: ${value}`)
    return value
  }

  unmarkSso() {
    this.logSso(`Removing client SSO session marker`)
    localStorage.removeItem(SSO_MARKER)
  }

  logSso(message: string) {
    LoggerUtils.log(message)
  }

  setInvalidSessionMarker() {
    storageProvider.setItem(SSO_INVALID_SESSION, '1')
  }

  isInvalidSessionMarked() {
    return !!storageProvider.getItem(SSO_INVALID_SESSION)
  }

  removeInvalidSessionMarker() {
    storageProvider.removeItem(SSO_INVALID_SESSION)
  }

  markSsoError(error: string) {
    this.logSso(`Marking client SSO error ${error}`)
    localStorage.setItem(SSO_ERROR_MESSAGE, error)
  }

  getSsoError() {
    const value = localStorage.getItem(SSO_ERROR_MESSAGE)
    this.logSso(`Checking client SSO error - value: ${value}`)
    return value
  }

  unmarkSsoError() {
    this.logSso(`Removing client SSO error`)
    localStorage.removeItem(SSO_ERROR_MESSAGE)
  }
}

export default new SsoUtils()
